module.exports = __webpack_public_path__ + "static/img/2.42cbf7f2.jpg";